export default __webpack_public_path__ + "static/media/9297.efdaa569.svg";